import { render, staticRenderFns } from "./date-picker.component.vue?vue&type=template&id=5b65a04a&"
import script from "./date-picker.component.vue?vue&type=script&lang=ts&"
export * from "./date-picker.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports